import { useContext } from 'react';
import { DataContext } from 'entries/common/widgets/context';
import { TRobotintConfig } from '../types/robotint-config.type';

export const useRobotintConfig = (): TRobotintConfig => {
  const data = useContext(DataContext);

  return {
    clientId: data!.env.ROBOTINT_CLIENT_ID,
    secret: data!.env.ROBOTINT_SECRET,
    robotintLink: data!.env.ROBOTINT_LINK,
  };
};
